module.exports = __webpack_public_path__ + "static/media/l_citizencan_logo.82b678cb.png";